import { useState } from 'react'

import { SecondaryActionItem } from '@factorialco/f0-react/dist/experimental'
import { ArrowCycle } from '@factorialco/f0-react/icons/app'

import { track } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { Modals, ModalsProps } from 'modules/integrations/components/SyncButton/Modals'
import { useIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'

export type UseSyncActionProps = {
  onConfirmSync?: ModalsProps['onConfirm']
  confirmTrackingEvent?: string
}

type UseSyncActionReturn = {
  dataCollectionSyncAction: SecondaryActionItem | null
  syncModal: React.ReactNode | null
}

export const useSyncAction = ({
  onConfirmSync,
  confirmTrackingEvent,
}: UseSyncActionProps = {}): UseSyncActionReturn => {
  const { syncEnabled, marketplaceIntegration, isSyncRunning } = useIntegrationsSyncContext()
  const [showModal, setShowModal] = useState(false)

  if (!syncEnabled || !marketplaceIntegration)
    return {
      dataCollectionSyncAction: null,
      syncModal: null,
    }

  return {
    dataCollectionSyncAction: {
      label: i18n.t('compensations.integrations.sync_action', {
        integration_name: marketplaceIntegration.name,
      }),
      icon: ArrowCycle,
      loading: isSyncRunning,
      onClick: () => {
        setShowModal(true)

        if (confirmTrackingEvent) {
          track(confirmTrackingEvent)
        }
      },
    },
    syncModal: showModal ? <Modals setShowModal={setShowModal} onConfirm={onConfirmSync} /> : null,
  }
}
